import api from "@/api";
export default class StockRequest {
  constructor(rawdata = {}) {
    // this.id = rawdata.id ? rawdata.id : null;
    this.id = rawdata.id ? rawdata.id : 0;
    this.part_id = rawdata.part_id ? rawdata.part_id : "";
    this.part_no = rawdata.part_no ? rawdata.part_no : "";
    this.quantity = rawdata.quantity ? rawdata.quantity : 0;
    this.description = rawdata.description ? rawdata.description : "";
    this.request_status = rawdata.request_status ? rawdata.request_status : "";

    // status enum
    // 0 - For Approval
    // 1 - Approved
    // 2 - Disapproved
  }

  static async create(payload) {
    const result = await api.post(
      `/api/v1/purchase/store_request_item/`,
      payload
    );
    if (result && result.status == 200) return result.data.data;

    return null;
  }

  static async fetch(id) {
    const result = await api.get(
      `/api/v1/purchase/view_request_item/?id=${id}&status=all`
    );
    if (result && result.status == 200) return result.data.data[0];

    return null;
  }

  static async delete(ids) {
    const result = await api.post(`/api/v1/purchase/delete_request/`, {
      ids: ids
    });
    if (result && result.status == 200) return result.data.data;

    return null;
  }

  static async bulkApprove(payload) {
    const result = await api.get(`/api/v1/purchase/bulk/`, payload);
    if (result && result.status == 200) return result.data.data;

    return null;
  }

  static async validate(part_id) {
    const result = await api.post(`/api/v1/purchase/check/`, {
      part_id: part_id
    });
    if (result && result.status == 200) return result.data.data;

    return null;
  }

  static rules() {
    return {
      part_id: [
        {
          required: true,
          message: "Part is required.",
          trigger: "blur"
        }
      ],
      quantity: [
        {
          required: true,
          message: "Quantity is required.",
          trigger: "blur"
        },
        {
          type: "number",
          message: "Quantity should be a number",
          trigger: "blur"
        },
        {
          type: "number",
          min: 1,
          message: "Quantity should be not less than 1",
          trigger: "blur"
        }
      ]
    };
  }
}
